import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { PasswordInput } from "@/components/ui/password-input";

const firstNameOf = (u) =>
  ((u?.display_name || u?.name || "").trim().split(/\s+/)[0]) || "there";

export default function FirstLoginSetup() {
  const { user, setPassword } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const name = firstNameOf(user);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("Give it at least 8 characters — a little extra keeps you safe."); return; }
    if (pw !== confirm) { setError("Those two didn't match. Try typing it once more."); return; }
    setLoading(true);
    const res = await setPassword(pw);
    setLoading(false);
    if (!res.success) setError(res.error || "Something went wrong — give it another try in a moment.");
    // On success, checkAuth() flips must_change_password off and this screen unmounts.
  };

  return (
    <div className="fls-root" data-testid="first-login-setup">
      <div className="fls-card">
        <div className="fls-brand">GT L.A.B Careers</div>
        <h1 className="fls-greeting" data-testid="fls-greeting">Welcome, {name}.</h1>
        <p className="fls-sub">
          Let's make this space yours. Set a password you'll remember — you only do this once.
        </p>
        <form onSubmit={submit} className="fls-form">
          <label className="fls-label" htmlFor="fls-new">Create your password</label>
          <PasswordInput
            id="fls-new"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="At least 8 characters"
            required
            data-testid="fls-new-password"
            className="fls-input"
          />
          <label className="fls-label" htmlFor="fls-confirm">Type it once more</label>
          <PasswordInput
            id="fls-confirm"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirm your password"
            required
            data-testid="fls-confirm-password"
            className="fls-input"
          />
          {error && <div className="fls-error" data-testid="fls-error">{error}</div>}
          <button type="submit" className="fls-submit" disabled={loading} data-testid="fls-submit">
            {loading ? "Saving…" : "Save & step inside"}
          </button>
        </form>
        <p className="fls-foot">This is just for you. Gia can always help if you get stuck.</p>
      </div>
    </div>
  );
}
